import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { SpinnerService } from '../services/spinner.service';
import { inject } from '@angular/core';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(SpinnerService);

  const urlWithoutSpinner = [
    '/users/getUserDataDetail',
    '/users/getUserRecognitions',
    '/GetCatContests',
  ];
  if (urlWithoutSpinner.find((url) => req.url.includes(url))) {
    return next(req);
  }

  if (req.url.includes('/users/getUserData')) {
    spinnerService.show('userData');
    return next(req).pipe(finalize(() => spinnerService.hide('userData')));
  }

  spinnerService.show();
  return next(req).pipe(finalize(() => spinnerService.hide()));
};
